import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { UserIcon } from "@gemini/icons";
import { Avatar } from "@gemini/ui";
import { useContactContext, useUserData } from "@/contexts/contact";
import { useI18n } from "@/shared/hooks";
import { getSalutationLabel } from "../utils";
export const UserInfos = () => {
    const { t } = useI18n();
    const { isFullNameForm } = useContactContext();
    const userData = useUserData();
    if (!userData)
        return null;
    const { firstName, lastName, fullName, salutation } = userData;
    const completeNameLabel = `${getSalutationLabel(t, salutation)} ${isFullNameForm ? `${firstName} ${lastName}` : fullName}`;
    return (_jsx(Box, { borderRadius: "radius.16", paddingHorizontal: "spacing.16", paddingVertical: "spacing.12", borderColor: "color.border.light.default", borderWidth: "borderWidth.1", borderStyle: "solid", backgroundColor: "color.surface.constant.white.default", children: _jsxs(Box, { display: "flex", flexDirection: "row", gap: "spacing.16", alignItems: "center", children: [_jsx(Avatar, { label: completeNameLabel, type: "circle", size: "48", icon: UserIcon }), _jsx(Box, { typography: "typography.body.16.bold", children: completeNameLabel })] }) }));
};
